(function () {
  if (window.__smCardProductInit) return;
  window.__smCardProductInit = true;

  var SVG_NS = 'http://www.w3.org/2000/svg';
  var TOAST_DURATION = 3800;
  var TOAST_EXIT = 280;

  function setLoading(btn, loading) {
    btn.dataset.loading = loading ? 'true' : 'false';
    btn.disabled = loading;
  }

  function restoreLabel(btn, label) {
    var span = btn.querySelector('.sm-card__atc-label');
    if (span) span.textContent = label;
    else btn.textContent = label;
  }

  function readLabel(btn) {
    var span = btn.querySelector('.sm-card__atc-label');
    return span ? span.textContent : btn.textContent;
  }

  function updateCartBubble(sections) {
    if (!sections || !sections['cart-icon-bubble']) return;
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;
    var parser = new DOMParser();
    var doc = parser.parseFromString(sections['cart-icon-bubble'], 'text/html');
    var updated = doc.querySelector('#cart-icon-bubble');
    if (!updated) return;
    while (bubble.firstChild) bubble.removeChild(bubble.firstChild);
    while (updated.firstChild) bubble.appendChild(updated.firstChild);
  }

  function readProductFromCard(btn) {
    var card = btn.closest('[data-sm-card]');
    if (!card) return { title: '', image: '' };
    var titleEl = card.querySelector('.sm-card__title a, .sm-card__title');
    var imgEl = card.querySelector('.sm-card__image--primary, .sm-card__image');
    var img = '';
    if (imgEl) {
      img = imgEl.currentSrc || imgEl.src || '';
    }
    return {
      title: titleEl ? titleEl.textContent.trim() : '',
      image: img,
    };
  }

  function createSvg(viewBox, pathD, className) {
    var svg = document.createElementNS(SVG_NS, 'svg');
    svg.setAttribute('viewBox', viewBox);
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    if (className) svg.setAttribute('class', className);
    var p = document.createElementNS(SVG_NS, 'path');
    p.setAttribute('d', pathD);
    p.setAttribute('fill', 'currentColor');
    svg.appendChild(p);
    return svg;
  }

  function showToast(opts) {
    opts = opts || {};
    var isError = opts.variant === 'error';

    var existing = document.querySelector('.sm-toast');
    if (existing) {
      existing.classList.remove('sm-toast--visible');
      setTimeout(function () { if (existing.parentNode) existing.remove(); }, 50);
    }

    var toast = document.createElement('aside');
    toast.className = 'sm-toast' + (isError ? ' sm-toast--error' : '');
    toast.setAttribute('role', isError ? 'alert' : 'status');
    toast.setAttribute('aria-live', isError ? 'assertive' : 'polite');

    var thumb = null;
    if (!isError) {
      thumb = document.createElement('div');
      thumb.className = 'sm-toast__thumb';
      if (opts.image) {
        var img = document.createElement('img');
        img.src = opts.image;
        img.alt = '';
        img.loading = 'lazy';
        img.decoding = 'async';
        thumb.appendChild(img);
      } else {
        thumb.appendChild(createSvg('0 0 24 24', 'M21 5h-7.59L12 3.59 10.59 5H3v14h18V5zM3 7h18l-9 6-9-6z', 'sm-toast__thumb-fallback'));
      }
    }

    var body = document.createElement('div');
    body.className = 'sm-toast__body';

    var head = document.createElement('div');
    head.className = 'sm-toast__head';
    var iconWrap = document.createElement('span');
    iconWrap.className = 'sm-toast__check';
    if (isError) {
      iconWrap.appendChild(createSvg('0 0 24 24', 'M18.3 5.71 12 12.01l-6.3-6.3-1.41 1.41 6.3 6.29-6.3 6.3 1.41 1.41 6.3-6.3 6.3 6.3 1.41-1.41-6.3-6.3 6.29-6.29z'));
    } else {
      iconWrap.appendChild(createSvg('0 0 24 24', 'M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z'));
    }
    var heading = document.createElement('span');
    heading.className = 'sm-toast__heading';
    heading.textContent = isError ? "Couldn't add to cart" : 'Added to cart';
    head.appendChild(iconWrap);
    head.appendChild(heading);

    var title = document.createElement('p');
    title.className = 'sm-toast__title';
    if (isError) {
      title.textContent = opts.message || 'Please try again.';
    } else {
      title.textContent = opts.title || 'Item';
    }

    body.appendChild(head);
    body.appendChild(title);

    if (isError && opts.title) {
      var sub = document.createElement('p');
      sub.className = 'sm-toast__subtitle';
      sub.textContent = opts.title;
      body.appendChild(sub);
    }

    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'sm-toast__close';
    close.setAttribute('aria-label', 'Dismiss');
    close.appendChild(createSvg('0 0 24 24', 'M18.3 5.71 12 12.01l-6.3-6.3-1.41 1.41 6.3 6.29-6.3 6.3 1.41 1.41 6.3-6.3 6.3 6.3 1.41-1.41-6.3-6.3 6.29-6.29z'));

    if (thumb) toast.appendChild(thumb);
    toast.appendChild(body);
    toast.appendChild(close);
    document.body.appendChild(toast);

    var dismissTimer;
    var dismiss = function () {
      clearTimeout(dismissTimer);
      toast.classList.remove('sm-toast--visible');
      setTimeout(function () {
        if (toast.parentNode) toast.parentNode.removeChild(toast);
      }, TOAST_EXIT);
    };

    close.addEventListener('click', dismiss);
    toast.addEventListener('mouseenter', function () { clearTimeout(dismissTimer); });
    toast.addEventListener('mouseleave', function () {
      dismissTimer = setTimeout(dismiss, 1500);
    });

    // Force a reflow so the browser paints the initial (off-screen) state
    // before we add the visible class — otherwise the transition is skipped.
    // eslint-disable-next-line no-unused-expressions
    toast.offsetHeight;
    requestAnimationFrame(function () {
      toast.classList.add('sm-toast--visible');
    });

    dismissTimer = setTimeout(dismiss, TOAST_DURATION);
  }

  function onClick(event) {
    var btn = event.target.closest('[data-sm-card-add]');
    if (!btn) return;
    event.preventDefault();

    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    var product = readProductFromCard(btn);
    var originalLabel = readLabel(btn);
    setLoading(btn, true);
    restoreLabel(btn, 'Adding…');

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');
    formData.append('sections', 'cart-icon-bubble');
    formData.append('sections_url', window.location.pathname);

    fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: formData,
    })
      .then(function (r) {
        return r.json().then(function (b) {
          return { ok: r.ok, body: b };
        });
      })
      .then(function (res) {
        if (!res.ok || res.body.status) {
          var msg = (res.body && (res.body.description || res.body.message)) || 'Could not add to cart';
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'sm-card-product',
              productVariantId: variantId,
              errors: res.body.errors || res.body.description,
              message: res.body.message,
            });
          }
          throw new Error(msg);
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'sm-card-product',
            productVariantId: variantId,
            cartData: res.body,
          });
        }

        updateCartBubble(res.body.sections);

        if (res.body && res.body.product_title) {
          product.title = res.body.product_title;
        }
        if (res.body && res.body.image) {
          product.image = res.body.image;
        }
        // Success no longer shows a toast — sm-cart-drawer-trigger.js opens the
        // cart drawer on every successful /cart/add. The error path below keeps
        // its toast, since the drawer can't convey a failed add.

        restoreLabel(btn, 'Added');
        setTimeout(function () {
          restoreLabel(btn, originalLabel);
          setLoading(btn, false);
        }, 1400);
      })
      .catch(function (err) {
        console.warn('[sm-card-product] add failed:', err && err.message);
        showToast({
          variant: 'error',
          message: (err && err.message) || 'Please try again.',
          title: product.title,
        });
        restoreLabel(btn, 'Try again');
        setTimeout(function () {
          restoreLabel(btn, originalLabel);
          setLoading(btn, false);
        }, 1600);
      });
  }

  document.addEventListener('click', onClick);

  // Intercept ANY product form submitting to /cart/add (PDP {% form 'product' %},
  // custom AI blocks, etc) so the page doesn't navigate to /cart on success.
  function onProductFormSubmit(event) {
    var form = event.target;
    if (!form || form.tagName !== 'FORM') return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;

    event.preventDefault();

    var submitBtn = form.querySelector('[type="submit"]');
    var originalText = submitBtn ? submitBtn.textContent : '';
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.dataset.smOriginalText = originalText;
      submitBtn.textContent = 'Adding…';
    }

    var formData = new FormData(form);
    formData.append('sections', 'cart-icon-bubble');
    formData.append('sections_url', window.location.pathname);

    var titleEl = document.querySelector('.product__title, .ai-product-info-title, h1');
    var imgEl = document.querySelector('.product__media img, .ai-product-info-main-image, .product-image img');
    var product = {
      title: titleEl ? titleEl.textContent.trim() : '',
      image: imgEl ? (imgEl.currentSrc || imgEl.src || '') : '',
    };

    fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: formData,
    })
      .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
      .then(function (res) {
        if (!res.ok || res.body.status) {
          throw new Error((res.body && (res.body.description || res.body.message)) || 'Could not add to cart');
        }
        updateCartBubble(res.body.sections);
        if (res.body.product_title) product.title = res.body.product_title;
        if (res.body.image) product.image = res.body.image;
        showToast(product);
        if (submitBtn) {
          submitBtn.textContent = 'Added';
          setTimeout(function () {
            submitBtn.textContent = submitBtn.dataset.smOriginalText || 'Add to Cart';
            submitBtn.disabled = false;
          }, 1400);
        }
      })
      .catch(function (err) {
        console.warn('[sm-card-product] PDP add failed:', err && err.message);
        showToast({
          variant: 'error',
          message: (err && err.message) || 'Please try again.',
          title: product.title,
        });
        if (submitBtn) {
          submitBtn.textContent = 'Try again';
          setTimeout(function () {
            submitBtn.textContent = submitBtn.dataset.smOriginalText || 'Add to Cart';
            submitBtn.disabled = false;
          }, 1600);
        }
      });
  }

  document.addEventListener('submit', onProductFormSubmit, true);

  // Suppress the cart-drawer auto-open from any source (PDP product-form,
  // related-products, etc) and surface a toast in its place. The cart icon
  // remains a link to /cart, so users can still see their full cart.
  function suppressDrawer() {
    var registry = window.customElements;
    if (!registry || !registry.get) return;
    ['cart-drawer', 'cart-notification'].forEach(function (name) {
      var Ctor = registry.get(name);
      if (Ctor && Ctor.prototype && Ctor.prototype.open && !Ctor.prototype.__smOpenStubbed) {
        // Preserve the real open() for deliberate, user-initiated opens
        // (header cart icon). Auto-open stays suppressed via the stub below,
        // so add-to-cart still shows the toast instead of sliding the drawer.
        Ctor.prototype.__smRealOpen = Ctor.prototype.open;
        Ctor.prototype.open = function () { /* auto-open suppressed by sm-toast */ };
        Ctor.prototype.__smOpenStubbed = true;
      }
    });
  }

  // Run after Dawn's components have registered.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', suppressDrawer);
  } else {
    suppressDrawer();
  }
  // Also retry once more in case the components register late.
  setTimeout(suppressDrawer, 1500);

  // When any source (PDP product-form, etc) publishes cartUpdate, show the
  // toast. Card clicks are skipped because cardJS shows its own toast inline.
  function subscribeToCartUpdate() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') {
      return setTimeout(subscribeToCartUpdate, 500);
    }
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (!event) return;
      if (event.source === 'sm-card-product') return; // cardJS already toasted
      // 'cart-items' source fires on qty change AND remove from the cart page
      // itself — user is on /cart, doesn't need a "Added to cart" confirmation.
      if (event.source === 'cart-items') return;

      var cartData = event.cartData || {};
      var product = {
        title: cartData.product_title || cartData.title || '',
        image: cartData.image || cartData.featured_image || '',
      };
      showToast(product);

      // Also forcibly close any drawer that may have flashed open.
      document.querySelectorAll('cart-drawer, cart-notification').forEach(function (el) {
        if (typeof el.close === 'function') el.close();
      });
    });
  }
  subscribeToCartUpdate();
})();
